<template>
  <el-dialog title="交接单"
             :append-to-body="true"
             :visible.sync="showTag"
             width="70%"
             :close-on-click-modal="false">
    <h3 class="flex jcc">危重患者院际转运病情交接单（{{ type === 'out' ? '转出' : '转入' }}）</h3>
    <p class="fs12 flex jcc color_main">{{ now }}</p>
    <h4>基本信息</h4>
    <p class="fs14">姓名：{{ info.patName }}

      性别：{{ info.patGender|sexFilter() }}

      年龄：{{ info.patAge }}

      患方联系人：{{ info.familyContactsName }}

      手机：{{ info.familyContactsMobile }}</p>

    <h4>转运信息</h4>

    <section>
      <p class="flex pr10"><span class="flex0">出发医院/科室：</span>
        <el-input size="mini" v-model="form.initDeptName"></el-input>
      </p>
      <p class="flex pr10"><span class="flex0">联系人：</span>
        <el-input size="mini" v-model="form.initContactPerson"></el-input>
      </p>
      <p class="flex pr10"><span class="flex0">电话：</span>
        <el-input size="mini" v-model="form.initTelephone"></el-input>
      </p>
    </section>

    <section>
      <p class="flex pr10"><span class="flex0">目的医院/科室：</span>
        <el-input size="mini" v-model="form.acceptDeptName"></el-input>
      </p>
      <p class="flex pr10"><span class="flex0">联系人：</span>
        <el-input size="mini" v-model="form.acceptContatPerson"></el-input>
      </p>
      <p class="flex pr10"><span class="flex0">电话：</span>
        <el-input size="mini" v-model="form.acceptTelephone"></el-input>
      </p>
    </section>

    <section>
      <p>转运车辆单位：{{ info.transportHosName }}</p>
      <p>医师：{{ doc.emergencyPersonnelName }}</p>
      <p>电话：{{ doc.emergencyPersonnelMobile }}</p>
    </section>
    <h4>
      主要病情
    </h4>
    <p>诊断：{{ info.tentativeDiagnosis }}</p>
    <p>关键病情经过：</p>
    <p>
      <el-input type="textarea" v-model="form.transhipmentProcessIllnessDesc"></el-input>
    </p>

    <h4>目前状况：</h4>
    <el-form ref="form" :model="form" size="mini" label-width="90px">
      <el-form-item label="生命体征：">
        <div class="flex">
          <p class="w200 flex">
            <span class="w30">T</span>
            <el-input class="w60" v-model="form.vitalSignsTemperature" @input="twInput"></el-input>
            ℃
          </p>
          <p class="w200 flex">
            <span class="w50">P</span>
            <el-input class="w60" v-model="form.vitalSignsPulse"
                      @input="commonInput('vitalSignsPulse',3,'脉搏')"></el-input>
            次/min
          </p>
          <p class="flex">
            <span class="w70">R</span>
            <el-input class="w60" v-model="form.vitalSignsRespire"
                      @input="commonInput('vitalSignsRespire',2,'呼吸')"></el-input>
            次/min
          </p>
        </div>
        <div class="flex mt5">
          <p class="w300 flex">
            <span class="w30">BP</span>
            <el-input class="w60" v-model="form.vitalSignsBloodPressureUpper"
                      @input="commonInput('vitalSignsBloodPressureUpper',3,'上压')"></el-input>
            /
            <el-input class="w60" v-model="form.vitalSignsBloodPressureLower"
                      @input="commonInput('vitalSignsBloodPressureLower',3,'下压')"></el-input>
            mmHg
          </p>
          <p class="w200 flex">
            <span class="w50">SpO2</span>
            <el-input class="w60" v-model="form.vitalSignsSpo2"
                      @input="commonInput('vitalSignsSpo2',3,'氧饱和度',100)"></el-input>
            %
          </p>
          <p class="flex">
            <span class="w70">疼痛评分</span>
            <el-input class="w60" v-model="form.painScore"
                      @input="commonInput('painScore',2,'疼痛评分',10,0)"></el-input>
            分
          </p>
        </div>
      </el-form-item>
      <el-form-item label="意识：">
        <div>
          GCS
          <el-input class="w50" v-model="form.gcsOpenEyesScore"
                    @input="commonInput('gcsOpenEyesScore',1,'睁眼反应评分')"></el-input>
          +
          <el-input class="w50" v-model="form.ggcsLanguageScore"></el-input>
          +
          <el-input class="w50" v-model="form.ggcsLimbsScore"></el-input>
          分
        </div>
        <div class="mt5">
          镇静/镇痛：
          <el-radio-group v-model="form.easePainStatus">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
          &nbsp;&nbsp;&nbsp;&nbsp;药物:
          <el-input class="w300" v-model="form.easePainMedicine"></el-input>
        </div>
        <div class="mt5 flex">
          <p>瞳孔：</p>
          <div>
            <p class="flex aic">
              【左】
              大小&nbsp;&nbsp;&nbsp;&nbsp;
              <el-input @input="commonInput('pupillaLeftSize',1,'瞳孔')" class="w50"
                        v-model="form.pupillaLeftSize"></el-input>
              mm，对光反射&nbsp;&nbsp;
              <el-radio-group v-model="form.pupillaLeftLightReflex">
                <el-radio :label="item" v-for="item in dgfs" :key="item">{{ item }}</el-radio>
              </el-radio-group>
            </p>
            <p class="mt5">
              【右】
              大小&nbsp;&nbsp;&nbsp;&nbsp;
              <el-input @input="commonInput('pupillaRightSize',1,'瞳孔')" class="w50"
                        v-model="form.pupillaRightSize"></el-input>
              mm，对光反射&nbsp;&nbsp;
              <el-radio-group v-model="form.pupillaRightLightReflex">
                <el-radio :label="item" v-for="item in dgfs" :key="item">{{ item }}</el-radio>
              </el-radio-group>
            </p>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="气道：">
        <p>
          <el-checkbox v-model="form.noArtificialAirwaySelectStatus">人工气道</el-checkbox>
          （
          <el-checkbox v-model="form.noArtificialAirwaySafeSelectStatus">安全</el-checkbox>
          <el-checkbox v-model="form.noArtificialAirwayNeedAttentionSelectStatus">需要注意</el-checkbox>
          ）
        </p>
        <div class="flex">
          <p class="w120">
            <el-checkbox label="气管插管" v-model="form.trachealIntubationSelectStatus"></el-checkbox>
          </p>
          <p>
            <el-input @input="commonInput('trachealIntubationDepth',2,'气管插管深度')"
                      v-model="form.trachealIntubationDepth"></el-input>
          </p>
        </div>

        <p>
          <el-checkbox v-model="form.tracheostomySelectStatus">气管切开</el-checkbox>
        </p>
      </el-form-item>
      <el-form-item label="循环功能：">
        <div class="flex">
          <p class="w120">
            <el-checkbox v-model="form.venousCatheterSelectStatus">静脉导管</el-checkbox>
          </p>
          <p>
            <el-input class="w300" v-model="form.venousCatheterSelectDesc"></el-input>
          </p>
        </div>
        <div class="flex">
          <p class="w120">
            <el-checkbox v-model="form.ductusArteriosusSelectStatus">动脉导管</el-checkbox>
          </p>
          <p>
            <el-input class="w300" v-model="form.ductusArteriosusSelectDesc"></el-input>
          </p>
        </div>
        <div class="flex">
          <p class="w120">
            <el-checkbox v-model="form.vasoactiveDrugsSelectStatus">血管活性药物</el-checkbox>
          </p>
          <p>
            <el-input class="w300" v-model="form.vasoactiveDrugsSelectDesc"></el-input>
          </p>
        </div>
        <div class="flex">
          <p class="w120">
            <el-checkbox v-model="form.cyclicFunctionOthersSelectStatus">其他支持</el-checkbox>
          </p>
          <p>
            <el-input class="w300" v-model="form.cyclicFunctionOthersSelectDesc"></el-input>
          </p>
        </div>
      </el-form-item>
      <el-form-item label="其他系统：">
        <div class="flex">
          <p class="w100">腹部：</p>
          <p>
            <el-radio-group v-model="form.abdominalContour">
              <el-radio label="隆起"></el-radio>
              <el-radio label="平"></el-radio>
              <el-radio label="凹陷"></el-radio>
            </el-radio-group>
          </p>
        </div>
        <div class="flex mt5">
          <p class="w100">肠鸣音：</p>
          <p>
            <el-input class="w50" @input="commonInput('intestinalSounds',2,'肠鸣音')"
                      v-model="form.intestinalSounds"></el-input>
            次/min
          </p>
        </div>
        <div class="flex mt5">
          <p class="w100">
            <el-checkbox label="压痛" v-model="form.tendernessPainSelectStatus"></el-checkbox>
          </p>
          <p>
            <el-input class="w300" v-model="form.tendernessPainSelectDesc"></el-input>
          </p>
        </div>
        <div class="flex mt5">
          <p class="w100">脊柱和骨盆：</p>
          <div>
            <div class="flex">
              <p class="w70">
                <el-checkbox label="损伤" v-model="form.spinalInjuriesSelectStatus"></el-checkbox>
              </p>
              <el-input class="w300" v-model="form.spinalInjuriesSelectDesc"></el-input>
            </div>
            <div class="mt5 flex">
              <p class="w70">
                <el-checkbox label="固定" v-model="form.spinalFixationSelectStatus"></el-checkbox>
              </p>
              <el-input class="w300" v-model="form.spinalFixationSelectDesc"></el-input>
            </div>
          </div>
        </div>
        <div class="flex mt5">
          <p class="w100">四肢：</p>
          <div>
            <div class="flex">
              <p class="w70">
                <el-checkbox label="骨折" v-model="form.limbFracturesSelectStatus"></el-checkbox>
              </p>
              <el-input class="w300" v-model="form.limbFracturesSelectDesc"></el-input>
            </div>
            <div class="mt5 flex">
              <p class="w70">
                <el-checkbox label="伤口" v-model="form.limbInjuriesSelectStatus"></el-checkbox>
              </p>
              <el-input class="w300" v-model="form.limbInjuriesSelectDesc"></el-input>
            </div>
          </div>
        </div>
        <div class="flex mt5">
          <p class="w100">
            <el-checkbox label="血管问题" v-model="form.bloodVesselSelectStatus"></el-checkbox>
          </p>
          <p>
            <el-input class="w300" v-model="form.bloodVesselSelectDesc"></el-input>
          </p>
        </div>
        <div class="flex mt5">
          <p class="w100">
            <el-checkbox label="神经问题" v-model="form.nerveSelectStatus"></el-checkbox>
          </p>
          <p>
            <el-input class="w300" v-model="form.nerveSelectDesc"></el-input>
          </p>
        </div>
        <div class="flex mt5">
          <p class="w100">管道情况：</p>
          <div>
            <div class="mt5 flex">
              <p class="w70">
                <el-checkbox label="尿道管" v-model="form.catheterSelectStatus"></el-checkbox>
              </p>
              <el-input class="w300" v-model="form.catheterSelectDesc"></el-input>
            </div>
            <div class="mt5 flex">
              <p class="w70">
                <el-checkbox label="引流管" v-model="form.drainageTubeSelectStatus"></el-checkbox>
              </p>
              <el-input class="w300" v-model="form.drainageTubeSelectDesc"></el-input>
            </div>
            <div class="mt5 flex">
              <p class="w70">
                <el-checkbox label="其他" v-model="form.conduitSelectStatus"></el-checkbox>
              </p>
              <el-input class="w300" v-model="form.conduitSelectDesc"></el-input>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="注意事项：">
        <el-input class="w300" type="textarea" v-model="form.mattersNeedingAttention"></el-input>
      </el-form-item>
      <el-form-item label="备注：" v-if="$route.query.aspectUser == 'init'">
        <el-input class="w300" type="textarea" v-model="form.remark"></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="8">
          <el-form-item label="交班人员：">
            <el-input v-model="form.handDutyName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="交班时间：">
            <el-date-picker type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="form.handDutyTime" :picker-options="{disabledDate}"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="接班人员：">
            <el-input v-model="form.takeDutyName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="接班时间：">
            <el-date-picker type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="form.takeDutyTime" :picker-options="{disabledDate}"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="sub">立即{{ id ? '修改' : '创建' }}</el-button>
        <el-button @click="hide">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {sexFilter, timeFilter} from "../../../common/lib/filters";
import {staffService} from "../service/staff";
import {STAFF_ADD_IN_OUT_FORM_FIELDS, sync_in_out_form_field} from "../config";
import {STAFF_ADD_IN_OUT_FORM_SUCCESS} from "../events";
import {disabledDate} from "../filter";
import {pickByArray} from "../../../common/lib/utils";

export default {
  name: "in-out-form-dialog",
  filters: {timeFilter, sexFilter},
  props: {
    info: {
      type: Object,
      default: () => Object.create(null)
    },
  },
  data() {
    return {
      id: "",
      type: '',
      data: {},
      dgfs: ['灵敏', '迟钝', '固定'],
      now: timeFilter(new Date(), 'YYYY-MM-DD HH:mm'),
      showTag: false,
      form: {
        pupillaLeftLightReflexStatus: ''
      }
    }
  },
  computed: {
    doc() {
      let list = this.info.emergencyStaffingList || [];
      list = list.filter(r => r.emergencyPersonnelType === "DOC") || [];
      return list[0] || {};
    },
  },
  methods: {
    disabledDate,
    async show(data, id) {
      this.type = data;
      this.id = id;
      await this.getData();
      this.setForm();
      this.showTag = true;
    },
    twInput() {
      let tw = this.form.vitalSignsTemperature;
      if (tw.length > 4) {
        this.$message.error('体温的格式应为 XX.X');
        tw = tw.substr(0, 4);
      }
      if (/[^\d\.]+/.test(tw)) {
        this.$message.error('请输入数字');
        tw = tw.replace(/[^\d\.]/, '');
      }
      if (/^[\d]{3}/.test(tw)) {
        this.$message.error('体温不能超过100℃');
        tw = tw.substr(0, 2);
      }
      this.form.vitalSignsTemperature = tw;

    },

    commonInput(field, length, label, max = false, min = false) {
      let mb = this.form[field];
      if (/[^\d]+/.test(mb)) {
        this.$message.error(label + '只能输入数字');
        mb = mb.replace(/[^\d]+/, '')
      }
      if (mb.length > length) {
        this.$message.error(label + '为' + length + '位数字');
        mb = mb.substr(0, length)
      }
      if (max) {
        if (parseInt(mb) > max) {
          this.$message.error(label + '最大值不能超过' + max);
          mb = max
        }
      }
      if (min !== false) {
        if (parseInt(mb) < min) {
          this.$message.error(label + '最小值不能小于' + min);
          mb = min
        }
      }
      this.form[field] = mb;
    },
    hide() {
      this.showTag = false;
    },
    setForm() {
      const {info, data} = this;
      info.initDocName && this.$set(this.form, 'initContactPerson', info.initDocName);
      info.initDocMobile && this.$set(this.form, 'initTelephone', info.initDocMobile);
      info.treatmentProcess && this.$set(this.form, 'transhipmentProcessIllnessDesc', info.treatmentProcess);
      STAFF_ADD_IN_OUT_FORM_FIELDS.forEach(r => {
        data && data[r] && this.$set(this.form, r, data[r]);
      });
      ["handDutyTime", "takeDutyTime"].forEach(r => {
        data && data[r] && this.$set(this.form, r, timeFilter(data[r], 'YYYY-MM-DD HH:mm:ss'));
      })
    },
    async getData() {
      const {info, type, id} = this;
      if (id) {
        this.data = await staffService.detailApply(info.id, type.toUpperCase());
      }
      /**
       * 入院交接单add,edit，信息自动从出院交接单
       */
      if (type === 'in') {
        const data = await staffService.detailApply(info.id, 'OUT');
        if (id) {
          this.data = Object.assign({}, pickByArray(data, sync_in_out_form_field), this.data);
        } else this.data = pickByArray(data, sync_in_out_form_field);
      }
    },
    async sub() {
      const {info, type, id} = this;
      const form = {...this.form};
      if (id) form.id = id;
      //form.vitalSignsBloodPressure = form.vitalSignsBloodPressure1 + '/' + form.vitalSignsBloodPressure2;
      form.emergencyReferralOrderId = info.id;
      form.applicationType = type.toUpperCase();
      if (await staffService.subApply(form)) {
        bus.$emit(STAFF_ADD_IN_OUT_FORM_SUCCESS.id, 0);
        this.$message.success(`${id ? '修改' : '添加'}成功！`);
        this.hide();
      }

    }
  },
}
</script>

<style lang="scss" scoped>
p {
  font-size: 14px;
  line-height: 30px;
}

h4 {
  line-height: 40px;
}

div > p > span {
  text-align: right;
  padding-right: 5px;
}

section {
  display: flex;

  p:nth-child(1) {
    width: 350px;
  }

  p:nth-child(2) {
    width: 300px;
  }

}
</style>
